import classnames from 'classnames';
import React from 'react';

import Helper from '@wetransfer/transfer/helper';
import Browser from '@wetransfer/transfer/modules/concorde-browser';

import styles from './PriceLabel.module.scss';
import { PriceLabelProps } from './types';

export const PriceLabel: React.FC<PriceLabelProps> = React.memo(
  function PriceLabel({ price, currency }) {
    return (
      <div
        className={classnames(styles.root, {
          [styles.rootHasSpacing]: !Browser.isMobile,
        })}
      >
        <h6 className={styles.label}>
          {Helper.getFormattedPrice(price, currency)}
        </h6>
      </div>
    );
  }
);
